module.exports = __webpack_public_path__ + "img/example3.326c124c.png";